import { Alert } from '@/components/assistant/alert/Alert'
import { ArchivedAlerts } from '@/components/assistant/alert/ArchivedAlerts'
import { AssistantMessage } from '@/components/assistant/messages/AssistantMessage'
import { Alert as AlertType } from '@/store/alert'
import { Beneficiary } from '@/store/beneficiary'
import { AlertStatus } from '@repo/shared/dtos/alert'
import { useT } from '@repo/ui/hooks'
import { useMemo } from 'react'

export function Alerts({
  alerts,
  beneficiaries,
}: {
  alerts: AlertType[]
  beneficiaries: Beneficiary[]
}) {
  const { t } = useT({ keyPrefix: 'assistant' })
  const shownAlerts = useMemo(
    () => alerts.filter((alert) => alert.status !== AlertStatus.ARCHIVED),
    [alerts],
  )
  const archivedAlerts = useMemo(
    () => alerts.filter((alert) => alert.status === AlertStatus.ARCHIVED),
    [alerts],
  )

  return (
    <div className="flex flex-col gap-4 px-4 pb-4">
      {shownAlerts.map((alert) => {
        const beneficiary = beneficiaries.find(
          (b) => alert.beneficiaryId === b.id,
        )
        if (!beneficiary) return null
        return <Alert key={alert.id} alert={alert} beneficiary={beneficiary} />
      })}

      {archivedAlerts.length > 0 && (
        <AssistantMessage className="select-none">
          {t('alert.seeArchivedAlerts')}{' '}
          <ArchivedAlerts
            archivedAlerts={archivedAlerts}
            beneficiaries={beneficiaries}
          />
        </AssistantMessage>
      )}
    </div>
  )
}
